import React from 'react';
import ReactDOM from 'react-dom/client';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

const stripePromise = loadStripe('pk_live_51QK8PzE9Em7Q9DaCnXLlx157cv70WsJbHKRWezeQWULgOh1PF5o6uWTdkYQgBKEqPMhloVJoeRWcCamk3U6Fbn5b00zJB8B1es');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Elements stripe={stripePromise}>
      <App />
    </Elements>
  </React.StrictMode>
);

reportWebVitals();
